import React from "react";
import PropTypes from "prop-types";
import Ellipses from "../../components/Ellipses";
import WrapperPage from "../../components/WrapperPage";
import { useTranslation } from "react-i18next";
import "./style.scss";
import PwaScreenIos1 from "../../assets/images/pwa_screen_ios_1.png";
import PwaScreenIos2 from "../../assets/images/pwa_screen_ios_2.png";
import PwaScreenIos3 from "../../assets/images/pwa_screen_ios_3.png";
import PwaScreenIos4 from "../../assets/images/pwa_screen_ios_4.png";
import PwaScreenIos5 from "../../assets/images/pwa_screen_ios_5.png";
import PwaScreenMac1 from "../../assets/images/pwa_screen_mac_1.png";
import PwaScreenMac2 from "../../assets/images/pwa_screen_mac_2.png";
import PwaScreenMac3 from "../../assets/images/pwa_screen_mac_3.png";
import PwaScreenAndroid1 from "../../assets/images/pwa_screen_android_1.png";
import PwaScreenAndroid2 from "../../assets/images/pwa_screen_android_2.png";
import PwaScreenAndroid3 from "../../assets/images/pwa_screen_android_3.png";
import PwaScreenAndroid4 from "../../assets/images/pwa_screen_android_4.png";
import PwaScreenOther1 from "../../assets/images/pwa_screen_other_devices_1.png";
import PwaScreenOther2 from "../../assets/images/pwa_screen_other_devices_2.png";
import PwaScreenOther3 from "../../assets/images/pwa_screen_other_devices_3.png";
import PwaInstructionCard from "./components/PwaInstructionCard";

export default function PwaInstructionsPage() {
  const isIos = /iPhone/.test(navigator.userAgent);
  const isMacintosh = /Macintosh|iPod|iPad/.test(navigator.userAgent);
  const isAndroid = /Android/.test(navigator.userAgent);
  const isOther = !isIos && !isMacintosh && !isAndroid;
  // платформа для i18n-ключей и экранов (шаги 1–3) — считаем один раз, а не тернарник в каждой карточке
  const platform = isIos
    ? "ios"
    : isMacintosh
    ? "mac"
    : isAndroid
    ? "android"
    : "other";

  PwaInstructionsPage.propTypes = {
    typeRule: PropTypes.string,
  };
  const { t } = useTranslation();

  // экраны шагов 1–3 по платформе; шаги 4/5 — особые (iOS-4; шаг 5 = iOS/Mac vs Android)
  const [imageScreen1, imageScreen2, imageScreen3] = {
    ios: [PwaScreenIos1, PwaScreenIos2, PwaScreenIos3],
    mac: [PwaScreenMac1, PwaScreenMac2, PwaScreenMac3],
    android: [PwaScreenAndroid1, PwaScreenAndroid2, PwaScreenAndroid3],
    other: [PwaScreenOther1, PwaScreenOther2, PwaScreenOther3],
  }[platform];
  const imageScreen4 = isIos && PwaScreenIos4;
  const imageScreen5 = isIos || isMacintosh ? PwaScreenIos5 : PwaScreenAndroid4;

  return (
    <div className="pwa_instructions-wrapper centering-page">
      <Ellipses className="rules-page-wrapper-ellipses" countEllipses={2} />
      <WrapperPage
        backBtn
        burgerMenu
        headerTitle={t(`pwa_instructions_${isIos ? "ios" : "android"}.title`)}
      >
        <div className="pwa_instructions">
          <div className="pwa_instructions__screen_wrapper">
            <PwaInstructionCard
              image={imageScreen1}
              text={t(`pwa_instructions_${platform}.step_1`)}
              bottomSpace={isIos}
              leftSpace={isIos || isAndroid}
              rightSpace={!isOther}
              topSpace={isMacintosh || isAndroid}
            />
            <PwaInstructionCard
              image={imageScreen2}
              text={t(`pwa_instructions_${platform}.step_2`)}
              leftSpace={isIos || isAndroid}
              rightSpace={isIos || isAndroid}
            />
            {/* L/R-отступ нужен только для телефон-скринов ios/android (789×660, ~1.195):
                в рамке ~1.23 они ложатся впритык. Десктоп-картинки mac/other (1005×720,
                1.396) БЕЗ отступа заполняют рамку 1.396 встык (как шаги 1–2); с отступом
                рамка сжималась до ~1.23 и вокруг картинки появлялась пустота (задвоение
                текста тут ни при чём — оно было в самой картинке, уже исправлено). */}
            <PwaInstructionCard
              image={imageScreen3}
              text={t(`pwa_instructions_${platform}.step_3`)}
              leftSpace={isIos || isAndroid}
              rightSpace={isIos || isAndroid}
              bottomSpace={isAndroid}
            />
            {isIos && (
              <PwaInstructionCard
                image={imageScreen4}
                text={t("pwa_instructions_ios.step_4")}
                topSpace
                leftSpace
                rightSpace
              />
            )}
            {(isIos || isAndroid) && (
              <PwaInstructionCard
                image={imageScreen5}
                text={t(`pwa_instructions_${isIos ? "ios" : "android"}.step_5`)}
              />
            )}
          </div>
        </div>
        <div className="pwa_instructions__important">
          {t(
            `pwa_instructions_${
              isIos || isMacintosh ? "ios" : "android"
            }.important`
          )}
        </div>
      </WrapperPage>
    </div>
  );
}
